import {  useState, useEffect } from 'react'
import styles from './PopulationScaling.module.scss'
import { useGeoState } from '../../components/GeoProvider'
import ErrorMessage from '../../components/Layout/ErrorMessage'
import LineChartTrend from  './lineChart'
import getVectorImage from '../../utils/getVectorImage'
import getCountyNameFromJson from '../../utils/getCountyNameFromJson'
const PopulationScaling = ({ geo_type, geo_id }) => {
  const [getScalingData, setScalingData] = useState()
  const [errorCode, setErrorCode] = useState()
  const [errorMessage, setErrorMessage] = useState()
  const [errorSubject, setErrorSubject] = useState()
  const [errorOccured, seterrorOccured] = useState(false)
    const [getCBSAJsonData, setCBSAJsonData] = useState()

 const { locationName } = useGeoState()
     useEffect(() => {
        fetch(
            `${process.env.REACT_APP_BACKEND_BASE_URL}/birthtrend/getpopulationscaling`,
            {
              method: 'post',
              headers: {
                'Content-Type': 'application/json',
                requester: JSON.stringify(window.localStorage.getItem('requester')),
              },
              body: JSON.stringify({
                geo_type:geo_type,
                geo_id:geo_id
              }),
              withCredentials: true,
              credentials: 'include',
            }
          )
             .then((response) => response.json())
            .then((resData)=>{
              if (resData !== null && resData !== undefined) {
                if (resData.status === 200) {
                  if(resData.data.length<=0 ||resData.data===""||resData===null)
                  {
                    setErrorCode(resData.status)
                    setErrorMessage(resData.message)
                    setErrorSubject(resData.subject)
                    seterrorOccured(true)
                  }
                  else{
                       setScalingData(resData.data)
                      seterrorOccured(false)
                  }
                }
                else{
                    setErrorCode(resData.status)
                    setErrorMessage(resData.message)
                    setErrorSubject(resData.subject)
                    seterrorOccured(true)
                }
              }
            }).catch((err) => {
                seterrorOccured(true)
              })},[1])
    
  useEffect(() => {
    let url = `${window.location.origin}/birthtrend/county.json`
    fetch(url)
      .then(function (res) {
        return res.json()
      })
      .then(function (data) {
        setCBSAJsonData(data)
      })
      .catch(function (err) {
        console.log(err, ' error file us_hrr_values ')
      })
  }, [1])
    if (errorOccured && errorCode!==200) {
      return (
        <ErrorMessage
          errorCode={errorCode}
          errorMessage={errorMessage}
          errorSubject={errorSubject}
          errorDetails={errorMessage+" for Population Scaling."}
        />
      )
    }

   
    return  (
    <div className={styles.base}>
      <div className={styles.maindivFormat}>
        <div className={styles.chartTitle}>
          
          <div className={styles.captionFormat}>
            {geo_id==='NAT'?'US':geo_type.toUpperCase()==='STATE'?locationName:getCBSAJsonData!==undefined&&getCountyNameFromJson(getCBSAJsonData,geo_id)} Population Scaling
           
            <div className={styles.subCaptionFormat}>
            {errorCode===200 && geo_type.toUpperCase()==='COUNTY'?
            <span>Data is unavailable for this region due to privacy protections for low populated areas.</span>
              :geo_id.toUpperCase()==='DC'?<span>Data is unavailable for this region.</span>
              :<span>This entails data that is shown on a dashboard consisting of national estimates given what we know of the UHG population and historical public information. Note: this is not a forecast, but a "now-cast".</span>
              }
            </div>
          
          </div>
            
          {/* <div className={styles.iconAI}>
            <button className={styles.buttonClass}>{getVectorImage('askai','20px','20px')} Ask AI</button>
          </div> */}
          </div>
         
        {getScalingData !== undefined  ? (
            <>
                <LineChartTrend data={getScalingData}/> 
            </>
          ) : null}
      </div>
     
    </div>
    
  ) 
}

export default PopulationScaling
